export const setDataVenda = data => ({
  type: '@vendas/SET_DATA_VENDA',
  payload: data,
});

export const setCodigoPontoVenda = codigo => ({
  type: '@vendas/SET_PDV',
  payload: codigo,
});
